import axios from "axios";
import authService from "../services/auth.service";
import constant from "./constant";

const instance = axios.create({
  baseURL: constant.URL,
});

instance.interceptors.request.use(
  (config) => {
    const authUser = authService.getAuthUser();
    if (authUser) {
      config.headers["authorization"] = `Bearer ${authUser.access_token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

instance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error?.response?.status === 401) {
      localStorage.removeItem("authUser");
      window.location.reload();
    } else if (error?.response) {
      const res = error.response;
      // Apache 400 HTML (Cookie-Header zu groß) → lesbare Meldung statt HTML-Toast
      if (
        typeof res.data === "string" &&
        /Bad Request|header field exceeds/i.test(res.data)
      ) {
        return Promise.reject({
          ...res,
          data: {
            message:
              "Anfrage vom Server abgelehnt (Cookie-Header zu groß). Bitte Cookies für flowliga.de löschen oder Hard-Reload — FightClub nutzt die API ohne Laravel-Cookies.",
            error: "bad_request_header",
          },
        });
      }
      return Promise.reject(res);
    } else {
      // Netzwerk / Proxy / Backend down — sonst landet nur generisches "Fehler" im UI
      return Promise.reject({
        status: 0,
        data: { message: error?.message || "Server nicht erreichbar" },
        message: error?.message || "Server nicht erreichbar",
      });
    }
  }
);

const get = (url, params, config = {}) =>
  instance.get(url, { params, ...config });
const post = (url, data, config = {}) => instance.post(url, data, config);

const methods = { get, post };

export default methods;
